import { MaxButton } from "components/view/button";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import create_token_invite_friend from "lib/worker/api/create_token_invite_friend";
import get_count_amount_member from "lib/worker/api/get_count_amount_member";
import get_win_lost_commission, {
  GetWinLostCommissionResponse,
} from "lib/worker/api/get_win_lost_commission";
import { GetServerSideProps } from "next";
import { useState } from "react";
import { useEffect } from "react";
import Img from "react-cloudimage-responsive";
import { connect } from "react-redux";
import get_transaction_commission_ranking_by_member_id from "lib/worker/api/get_transaction_commission_ranking_by_member_id";
import RuleAgentModal, {
  showRuleAgentModal,
} from "components/modal/rule_agent";

interface AgentProfileProps {
  state: AppReducerStateProps;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function AgentProfile(props: AgentProfileProps) {
  const { getinfo } = props.state.member;
  const { infomation } = props;
  const [linkRef, setLinkRef] = useState<string>();
  const [memberCount, setMemberCount] = useState<number>(0);
  const [commission, setCommission] = useState<GetWinLostCommissionResponse>();

  useEffect(() => {
    if (props.isLogin) {
      reload();
    }
  }, []);

  const reload = () => {
    get_transaction_commission_ranking_by_member_id();

    get_count_amount_member().then((json) => {
      setMemberCount(json);
    });

    get_win_lost_commission().then((json) => {
      setCommission(json);
    });
  };

  useEffect(() => {
    if (props.isLogin) {
      create_token_invite_friend()
        .then((link) => {
          setLinkRef(
            location.host + `/register/${infomation.prefix}` + "?token=" + link
          );
        })
        .catch(() => {
          setLinkRef("ไม่สามารถสร้างลิงก์ได้");
        });
      reload();
    }
  }, []);

  const copyToClipboard = (content: any) => {
    const el = document.createElement("input");
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  };

  const copysubmit = (e: any) => {
    let inviteFriendCopy: any = linkRef ?? "";
    e.target.textContent = "คัดลอกสำเร็จ";
    JSON.stringify(inviteFriendCopy);
    copyToClipboard(inviteFriendCopy);
  };

  return (
    <>
      <h1 style={{ float: "left", marginTop: 5 }}>
        <span>ข้อมูลตัวแทน</span>
      </h1>
      <div className="grid" style={{ width: 80, float: "right" }}>
        <MaxButton
          title="กติกา"
          className="text-center btn-purple-back margin-left-5"
          onClick={showRuleAgentModal}
        ></MaxButton>
      </div>
      <RuleAgentModal></RuleAgentModal>
      <div style={{ clear: "both" }}></div>
      <p>ยิ่งมีตัวแทนเยอะยิ่งจะได้รับเครดิตฟรีเพิ่มขึ้นสูงสุด 10%!!</p>
      <div className="card-ufa-category color-font-card border-ufa">
        <div className="grid row">
          <div
            style={{
              borderRadius: 20,
              width: 125,
              height: 125,
            }}
          >
            <div style={{ paddingTop: 0, paddingBottom: 0 }}>
              <Img
                ratio={0.9 / 1}
                className="full-width-image margin-top-10 margin-bottom-10"
                src={getinfo.Rank?.Image ?? ""}
                alt="ระดับตัวแทน คาสิโนออนไลน์"
              ></Img>
            </div>
          </div>
          <div className="col">
            <div style={{ marginTop: 18, marginLeft: 0 }}>
              <h2 className="font-bold" style={{ fontSize: 14 }}>
                {getinfo.Rank?.Name ?? "Loading ..."}
              </h2>
              <span className="font-info">EXP:</span>{" "}
              {getinfo.Rank?.MemberEXP?.format(0, 0) ?? "..."}
            </div>
            <div style={{ marginTop: 5 }}>
              <span className="font-info">ตัวแทนทั้งหมด:</span>{" "}
              {memberCount?.format(0, 0)} คน
            </div>
            <div style={{ marginTop: 5, marginBottom: 10 }}>
              <span className="font-info">ระดับถัดไป:</span>{" "}
              {getinfo.Rank?.MemberEXP?.format(0, 0) ?? "0"} /{" "}
              {getinfo.RankingMemberInfomation?.Exp?.format(0, 0)}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 margin-top-10">
          <div className="card-ufa-category color-font-card shadow card-body border-ufa">
            ได้/เสีย: {commission?.WinLost?.format(2, 0) ?? 0} เครดิต
          </div>
        </div>
        <div className="col-12 col-md-6 margin-top-10">
          <div className="card-ufa-category color-font-card shadow card-body border-ufa">
            รายได้: {((commission?.ProveComission ?? 0) * -1).format(2, 0) ?? 0}{" "}
            เครดิต
          </div>
        </div>
      </div>

      <h2 className="margin-top-20">
        <span>ลิงก์เชิญตัวแทน</span>
      </h2>
      <div className="container card-ufa-category color-font-card shadow card-body border-ufa">
        <div className="margin-left-10">
          <div className="row center-row-content">
            <div className="margin-right-15 margin-left-10">
              <h4
                style={{
                  wordBreak: "break-all",
                  fontSize: 14,
                }}
              >
                {linkRef ?? "..."}
              </h4>
            </div>
          </div>
          <div className="margin-right-5">
            <div className="bottom-line-yellow"></div>
          </div>
          <div>
            <MaxButton
              title="คัดลอก"
              className="text-center col-8 col-md-4 col-lg-3 bg-invite button-glowing center-row-content"
              onClick={copysubmit}
            ></MaxButton>
          </div>
        </div>
      </div>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(AgentProfile);
